import React from 'react'

import classnames from 'classnames'
import { Link } from 'react-router-dom'

import { api } from '../api'

export const Navbar: React.FC = () => {
  const [menuIsOpen, setMenuIsOpen] = React.useState(false)

  return (
    <nav
      className="navbar is-info is-fixed-top"
      role="navigation"
      aria-label="main navigation">
      <div className="navbar-brand">
        <Link className="navbar-item" to="/">
          {process.env.REACT_APP_APP_TITLE}
        </Link>
        <div
          className="navbar-burger"
          onClick={() => setMenuIsOpen(!menuIsOpen)}>
          <span />
          <span />
          <span />
        </div>
      </div>
      <div className={classnames('navbar-menu', { 'is-active': menuIsOpen })}>
        <div className="navbar-start">
          <Link
            className="navbar-item is-hidden-tablet"
            to="/channels"
            onClick={() => setMenuIsOpen(false)}>
            Channels
          </Link>
        </div>
        <div className="navbar-end">
          <div className="navbar-item">
            <div className="field is-grouped">
              <p className="control">
                <a
                  className="button is-small"
                  href={process.env.REACT_APP_FF_ADMIN}
                  target="_blank"
                  rel="noreferrer">
                  <span>FF Admin</span>
                  <span className="icon">
                    <i className="fas fa-external-link" aria-hidden="true" />
                  </span>
                </a>
              </p>
              <p className="control">
                <button
                  type="button"
                  className="button is-small"
                  onClick={async () => {
                    await api.logout()
                    window.location.reload()
                  }}>
                  <span>Déconnexion</span>
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </nav>
  )
}
